import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CircularCustomScale from './CircularCustomScale';
import ClientProvider from './client';
export default createDemo(import.meta.url, CircularCustomScale, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/progress/demos/circular-custom-scale/CircularCustomScale.tsx",
    "fileName": "CircularCustomScale.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport CircularProgress from '@mui/material/CircularProgress';\n\nexport default function CircularCustomScale() {\n  const [progress, setProgress] = React.useState(10);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 20 ? 10 : prevProgress + 2));\n    }, 800);\n\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <CircularProgress\n      variant=\"determinate\"\n      min={10}\n      max={20}\n      value={progress}\n      aria-label=\"Loading\"\n    />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 26,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport CircularProgress from '@mui/material/CircularProgress';\n\nexport default function CircularCustomScale() {\n  const [progress, setProgress] = React.useState(10);\n\n  React.useEffect(() => {\n    const timer = setInterval(() => {\n      setProgress((prevProgress) => (prevProgress >= 20 ? 10 : prevProgress + 2));\n    }, 800);\n\n    return () => {\n      clearInterval(timer);\n    };\n  }, []);\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <CircularProgress\n      variant=\"determinate\"\n      min={10}\n      max={20}\n      value={progress}\n      aria-label=\"Loading\"\n    />\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "CircularProgress"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "determinate",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "min"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "20"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "progress"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Loading",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            "    />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 26,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/CircularProgress"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
